import { Action } from "@/api-schema-enums";
import { Can, useAbility } from "@/casl-provider";
import { createRowNavigatePath } from "@/components/data-table/_helpers/create-row-navigate-path";
import { CompanyGroupTable } from "@/components/data-table/predefined/company-group-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";

const DEFAULT_PAGE_SIZE = 100;

export function CompanyGroupView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const ability = useAbility();
  const canManage = ability.can(Action.Manage, "CompanyGroup");
  const defaultRowActions = canManage
    ? undefined
    : {
        showEdit: false,
        showDelete: false,
      };

  return (
    <Can I="read" a="CompanyGroup">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("masterdata:CompanyGroups")}
        subTitle={t("common:SearchFilterAndManageEntriesDescription")}
      >
        <CompanyGroupTable
          pageSize={DEFAULT_PAGE_SIZE}
          showCreateButton={canManage}
          defaultRowActions={defaultRowActions}
          onRowNavigate={createRowNavigatePath("/masterdata/company-group")}
        />
      </CenteredLayout>
    </Can>
  );
}
